import { z } from 'zod'
import { zId, zIsoDate } from '../common'
import { zLinkStatus } from '../enums'

// An affiliate link. `targetKey` is an OPAQUE string (today `operator:orange`,
// tomorrow `insurer:axa:auto`) — the front must never parse it, validate its
// shape, or derive a business label from its prefix. The platform is
// deliberately sector-agnostic.
export const zAffiliateLink = z.object({
  id: zId,
  tenantId: zId,
  propertyId: zId,
  affiliatePartnerId: zId,
  targetKey: z.string(),
  targetUrl: z.string(),
  status: zLinkStatus,
  createdAt: zIsoDate,
  updatedAt: zIsoDate,
})
export type AffiliateLink = z.infer<typeof zAffiliateLink>
